import QuestionIndex from './QuestionIndex';

export default QuestionIndex;
